<script setup>
// ============================================================================
// BonBoZ: bảng "Thống kê chi tiết" — đủ 16 cột của Pancake, ba nút ở góc phải:
// [Theo ngày] [Theo giờ] [Tuỳ chỉnh].
//
// Biểu đồ ở trên trả lời "xu hướng đi lên hay đi xuống". Bảng này trả lời câu
// còn lại, và là câu trực page hỏi hằng ngày: "hôm qua bao nhiêu", "cái tụt là
// tụt từ ngày nào". Đọc con số chính xác trên biểu đồ là việc không làm được.
//
// MỚI NHẤT LÊN ĐẦU ở tab Theo ngày. Người xem mở bảng ra là để xem hôm qua,
// không phải để xem ngày đầu kỳ. Tab Theo giờ thì ngược lại — 0h → 23h, vì đó
// là thứ tự của một ngày, không phải thứ tự "mới nhất".
//
// BA CỘT TỈ LỆ TÍNH TẠI CHỖ, và tử số KHÔNG phải cột đang hiện cạnh nó:
//   Đơn chốt / KH mới      = don_chot_ro ÷ khach_moi
//   Đơn chốt / SĐT tr.ngày = sdt_va_chot ÷ sdt_moi
//   SĐT mới / KH mới       = sdt_moi     ÷ khach_moi
// Cả ba tử số đếm trên CÙNG rổ với mẫu số của chúng — rổ "khách LẦN ĐẦU nhắn
// tới" — nên tỉ lệ không bao giờ vượt 100%. Riêng cột thứ hai phải dùng
// `sdt_va_chot` chứ không phải `don_chot_ro`: khách được gắn `bill` mà chưa
// từng có `sđt` là chuyện có thật, chia thẳng thì vẫn vượt 100%. Cột "Số đơn chốt" và
// "SĐT trong ngày" hiện ra thì đếm theo NGÀY GẮN TAG — con số đúng cho câu
// "hôm đó chốt được mấy đơn", nhưng chia cho `khach_moi` thì ra 300%. Đúng cái
// bẫy đã làm trang Tổng quan hiện 600%. Chú giải từng cột nói rõ điều này.
//
// DÒNG TỔNG có ĐƠN VỊ dưới con số, đúng như Pancake — "86 Khách hàng" đọc ra
// nghĩa ngay, "86" thì phải ngước lên đầu cột.
// ============================================================================
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { ngay } from 'dashboard/helper/dinhDangNgay';
import {
  taiXuongExcel,
  tenFileThongKe,
} from 'dashboard/helper/bonboz/xuatExcel';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  dong: { type: Array, default: () => [] },
  tong: { type: Object, default: null },
  gom: { type: String, default: 'ngay' },
  dangTai: { type: Boolean, default: false },
});
const emit = defineEmits(['doiGom']);

const { t } = useI18n();

// Đủ 16 cột Pancake. `don_vi` là chữ nhỏ dưới con số ở dòng Tổng; `ti_le` thì
// giá trị tính tại chỗ từ ba khoá kia chứ không đọc thẳng từ dòng.
const COT = [
  { khoa: 'khach_moi', don_vi: 'DV_KHACH' },
  { khoa: 'sdt_ngay', don_vi: 'DV_SDT' },
  { khoa: 'sdt_moi', don_vi: 'DV_SDT' },
  { khoa: 'binh_luan_khach', don_vi: 'DV_BINH_LUAN' },
  { khoa: 'tin_khach', don_vi: 'DV_TIN' },
  { khoa: 'binh_luan_trang', don_vi: 'DV_BINH_LUAN' },
  { khoa: 'tin_trang', don_vi: 'DV_TIN' },
  { khoa: 'hoi_thoai', don_vi: 'DV_HOI_THOAI' },
  { khoa: 'khach_cu_nhan', don_vi: 'DV_KHACH' },
  { khoa: 'web_login', don_vi: 'DV_KHACH' },
  { khoa: 'web_khong', don_vi: 'DV_KHACH' },
  { khoa: 'don_chot', don_vi: 'DV_DON' },
  { khoa: 'chot_tren_khach', ti_le: ['don_chot_ro', 'khach_moi'] },
  { khoa: 'chot_tren_sdt', ti_le: ['sdt_va_chot', 'sdt_moi'] },
  { khoa: 'sdt_tren_khach', ti_le: ['sdt_moi', 'khach_moi'] },
];

// Các cột đếm NGƯỜI: dòng Tổng của chúng nhỏ hơn tổng cột là ĐÚNG, không phải
// lỗi cộng — một người nhắn hai ngày là 1 ở mỗi dòng nhưng vẫn là 1 người trong
// cả kỳ. Chú giải nói thẳng điều đó ngay tại ô, chứ để người đọc tự cộng lại
// rồi ngờ vực cả bảng thì tệ hơn nhiều.
const DEM_NGUOI = [
  'khach_moi',
  'sdt_ngay',
  'sdt_moi',
  'khach_cu_nhan',
  'web_login',
  'web_khong',
  'don_chot',
];

// ------------------------------------------------------------- chọn cột
// Lưu trong localStorage: người trực page mở bảng này mỗi ngày, bắt bỏ chọn lại
// 6 cột mỗi lần là bắt trả giá cho việc thường xuyên nhất. Hỏng hay bị chặn thì
// rơi về "hiện tất cả" — không có gì để phòng thủ thêm.
const KHOA_LUU = 'bonboz_cot_thong_ke_chi_tiet';
const doc = () => {
  try {
    const luu = JSON.parse(localStorage.getItem(KHOA_LUU));
    return Array.isArray(luu) && luu.length ? luu : null;
  } catch {
    return null;
  }
};
const cotHien = ref(doc() || COT.map(c => c.khoa));
watch(cotHien, giaTri => {
  try {
    localStorage.setItem(KHOA_LUU, JSON.stringify(giaTri));
  } catch {
    // Trình duyệt chặn lưu trữ thì bảng vẫn chạy, chỉ là mở lại phải chọn lại.
  }
});
const moChonCot = ref(false);
const cot = computed(() => COT.filter(c => cotHien.value.includes(c.khoa)));

const doiCot = khoa => {
  const co = cotHien.value.includes(khoa);
  // Không cho bỏ hết: bảng còn mỗi cột Thời gian thì không còn là bảng.
  if (co && cotHien.value.length === 1) return;
  cotHien.value = co
    ? cotHien.value.filter(k => k !== khoa)
    : COT.map(c => c.khoa).filter(k => cotHien.value.includes(k) || k === khoa);
};

// ------------------------------------------------------------- giá trị ô
// `null` khi mẫu bằng 0: "0%" nói rằng đã đo và ra không, còn ở đây là chưa có
// gì để đo. Hai chuyện khác nhau.
const tiLe = (nguon, [tu, mau]) => {
  const duoi = nguon?.[mau] ?? 0;
  return duoi > 0 ? Math.round(((nguon[tu] ?? 0) / duoi) * 1000) / 10 : null;
};

const oCua = (nguon, c) => {
  if (!c.ti_le) return nguon?.[c.khoa] ?? 0;
  const so = tiLe(nguon, c.ti_le);
  return so === null ? null : `${so}%`;
};

const hang = computed(() => {
  const ds = props.dong.map(d => ({
    ...d,
    // Tab giờ trả `moc` là số 0–23; tab ngày trả mốc thời gian thật.
    nhan:
      props.gom === 'gio'
        ? t('BONBOZ.TRANG_TK.KHUNG_GIO', { tu: d.moc, den: (d.moc + 1) % 24 })
        : ngay(d.moc * 1000, 'ngayDay'),
  }));
  // Ngày: mới nhất lên đầu. Giờ: 0h → 23h, thứ tự của một ngày.
  return props.gom === 'gio' ? ds : ds.sort((a, b) => b.moc - a.moc);
});

// ------------------------------------------------------------------ Excel
// Xuất ĐÚNG cái bảng đang hiện — cùng cột, cùng thứ tự dòng, cùng dòng Tổng —
// để file mở ra đối chiếu được với màn hình từng ô một. Khoảng ngày trong tên
// file lấy từ chính dữ liệu, không phải từ bộ lọc.
const xuatExcel = () => {
  const cacHang = [
    [
      t('BONBOZ.TRANG_TK.COT_NGAY'),
      ...cot.value.map(c => t(`BONBOZ.TRANG_TK.C_${c.khoa}`)),
    ],
    ...hang.value.map(d => [d.nhan, ...cot.value.map(c => oCua(d, c) ?? '')]),
  ];
  if (props.tong) {
    cacHang.push([
      t('BONBOZ.TRANG_TK.COT_TONG'),
      ...cot.value.map(c => oCua(props.tong, c) ?? ''),
    ]);
  }
  const moc = props.gom === 'gio' ? [] : props.dong.map(d => d.moc);
  taiXuongExcel(
    tenFileThongKe(
      `thong-ke-chi-tiet-${props.gom}`,
      moc.length ? Math.min(...moc) : null,
      moc.length ? Math.max(...moc) : null
    ),
    cacHang
  );
};

const TAB = [
  { khoa: 'ngay', nhan: 'TAB_NGAY' },
  { khoa: 'gio', nhan: 'TAB_GIO' },
];
</script>

<template>
  <section class="border rounded-xl border-n-weak bg-n-solid-2">
    <div class="flex flex-wrap items-start justify-between gap-3 p-4 pb-3">
      <div>
        <h3 class="m-0 text-sm font-semibold text-n-slate-12">
          {{ $t('BONBOZ.TRANG_TK.CHI_TIET') }}
        </h3>
        <p class="m-0 mt-0.5 text-xs text-n-slate-11">
          {{ $t('BONBOZ.TRANG_TK.CHI_TIET_MO_TA') }}
        </p>
      </div>

      <div class="flex items-center gap-2">
        <!-- Hai tab dính liền trong một khung bo tròn, đúng khuôn Pancake. -->
        <div class="flex p-0.5 rounded-lg bg-n-alpha-1">
          <button
            v-for="x in TAB"
            :key="x.khoa"
            type="button"
            class="px-3 py-1.5 text-sm rounded-md transition-colors"
            :class="
              gom === x.khoa
                ? 'bg-n-brand text-white font-medium'
                : 'text-n-slate-11 hover:text-n-slate-12'
            "
            @click="emit('doiGom', x.khoa)"
          >
            {{ $t(`BONBOZ.TRANG_TK.${x.nhan}`) }}
          </button>
        </div>

        <div class="relative">
          <Button
            variant="outline"
            color="slate"
            size="sm"
            icon="i-lucide-columns-3"
            :label="$t('BONBOZ.TRANG_TK.TUY_CHINH')"
            @click="moChonCot = !moChonCot"
          />
          <!-- Nền trong suốt phủ toàn màn: bấm ra ngoài là đóng, không cần
               nghe sự kiện trên document rồi phải nhớ gỡ. -->
          <div
            v-if="moChonCot"
            class="fixed inset-0 z-10"
            @click="moChonCot = false"
          />
          <div
            v-if="moChonCot"
            class="absolute right-0 z-20 flex flex-col gap-1 p-2 mt-1 border shadow-lg w-60 max-h-80 overflow-y-auto rounded-xl border-n-weak bg-n-solid-1"
          >
            <label
              v-for="c in COT"
              :key="c.khoa"
              class="flex items-center gap-2 px-2 py-1.5 text-sm rounded cursor-pointer text-n-slate-12 hover:bg-n-alpha-1"
            >
              <input
                type="checkbox"
                :checked="cotHien.includes(c.khoa)"
                class="accent-n-brand"
                @change="doiCot(c.khoa)"
              />
              {{ $t(`BONBOZ.TRANG_TK.C_${c.khoa}`) }}
            </label>
          </div>
        </div>

        <Button
          variant="ghost"
          color="slate"
          size="sm"
          icon="i-lucide-download"
          :label="$t('BONBOZ.XUAT.NUT')"
          :disabled="!hang.length"
          @click="xuatExcel"
        />
      </div>
    </div>

    <div
      v-if="dangTai"
      class="m-4 rounded-lg h-80 bg-n-alpha-2 animate-pulse"
    />

    <!-- Bảng tự cuộn cả hai chiều trong khung của nó; trang không bao giờ cuộn
         ngang. Đầu bảng và dòng Tổng dính lại khi cuộn dọc — 30 dòng mà mất
         tên cột thì mỗi con số là một câu đố. -->
    <div v-else class="overflow-auto max-h-[32rem]">
      <!-- BonBoZ: boc de cuon ngang. Bang nhieu cot hon be ngang man thi bi CAT
           cung chu khong cuon — tren dien thoai mat han cac cot ben phai. Hai man
           Cam xuc va Quang cao da boc dung tu truoc, day la lam not cho deu. -->
      <div class="overflow-x-auto">
        <table class="w-full text-sm border-collapse">
          <thead class="sticky top-0 z-10 bg-n-slate-2">
            <tr class="text-xs border-y border-n-weak text-n-slate-11">
              <th
                class="sticky left-0 z-10 w-32 px-3 py-2.5 font-medium bg-n-slate-2 text-start"
              >
                {{ $t('BONBOZ.TRANG_TK.COT_NGAY') }}
              </th>
              <th
                v-for="c in cot"
                :key="c.khoa"
                v-tooltip.top="$t(`BONBOZ.TRANG_TK.G_${c.khoa}`)"
                class="px-3 py-2.5 font-medium leading-snug align-bottom whitespace-nowrap text-end"
              >
                {{ $t(`BONBOZ.TRANG_TK.C_${c.khoa}`) }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="d in hang"
              :key="d.moc"
              class="border-b border-n-weak last:border-b-0 hover:bg-n-alpha-1"
            >
              <td
                class="sticky left-0 px-3 py-2 whitespace-nowrap bg-n-solid-2 text-n-slate-12"
              >
                {{ d.nhan }}
              </td>
              <td
                v-for="c in cot"
                :key="c.khoa"
                class="px-3 py-2 tabular-nums text-end"
                :class="oCua(d, c) ? 'text-n-slate-12' : 'text-n-slate-10'"
              >
                {{ oCua(d, c) ?? '—' }}
              </td>
            </tr>
          </tbody>

          <tfoot v-if="tong">
            <tr
              class="sticky bottom-0 text-sm border-t bg-n-slate-2 border-n-weak text-n-slate-12"
            >
              <td class="sticky left-0 px-3 py-2.5 font-semibold bg-n-slate-2">
                {{ $t('BONBOZ.TRANG_TK.COT_TONG') }}
              </td>
              <!-- Các cột đếm người mang thêm chú giải ngay tại ô: người đọc tự
                   cộng cột rồi thấy lệch sẽ ngờ vực cả bảng, mà chú thích cuối
                   bảng thì lúc đó họ chưa đọc tới. -->
              <td
                v-for="c in cot"
                :key="c.khoa"
                v-tooltip.top="
                  DEM_NGUOI.includes(c.khoa)
                    ? $t('BONBOZ.TRANG_TK.GT_TONG_NGUOI')
                    : undefined
                "
                class="px-3 py-2 text-end"
              >
                <span
                  class="block font-semibold tabular-nums"
                  :class="
                    DEM_NGUOI.includes(c.khoa)
                      ? 'underline decoration-dotted decoration-n-slate-8 underline-offset-4'
                      : ''
                  "
                >
                  {{ oCua(tong, c) ?? '—' }}
                </span>
                <span v-if="c.don_vi" class="block text-xxs text-n-slate-11">
                  {{ $t(`BONBOZ.TRANG_TK.${c.don_vi}`) }}
                </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <p class="px-4 py-2.5 m-0 text-xxs text-n-slate-11">
      {{ $t('BONBOZ.TRANG_TK.GT_TONG_NGUOI') }}
    </p>
  </section>
</template>
